import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"thumb-down-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.53936 4.69589L3.35474 12.3959C3.16835 13.6074 4.10571 14.7 5.33148 14.7H10.2003V18.154C10.2003 19.3161 10.9439 20.3479 12.0464 20.7154L12.9003 21L16.5003 12.9H20.0003V3H6.5161C5.52896 3 4.68946 3.72022 4.53936 4.69589Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.53936 4.69589L3.35474 12.3959C3.16835 13.6074 4.10571 14.7 5.33148 14.7H10.2003V18.154C10.2003 19.3161 10.9439 20.3479 12.0464 20.7154L12.9003 21L16.5003 12.9H20.0003V3H6.5161C5.52896 3 4.68946 3.72022 4.53936 4.69589Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ThumbDown1 = Vue.extend<IconProps>({
  name: 'ThumbDown1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'thumb-down-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ThumbDown1;
